// extracted by mini-css-extract-plugin
var _1 = "socialMediaSection-module__socialMediaButtons___tAxYp";
var _2 = "socialMediaSection-module__socialMediaSection___Fpd5k";
export { _1 as "socialMediaButtons", _2 as "socialMediaSection" }
